<div class="header-bar">
	<a [routerLink]="['/']"><img class='main-logo' src='./assets/images/header.png'></a>
</div>

